import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

/** Local replacement for @reflact/ngx-layout's OverlayService: tracks the "selected" overlay object via a query param. */
@Injectable({ providedIn: 'root' })
export class OverlayService {
  constructor(private router: Router, private route: ActivatedRoute) { }

  public get(key: string): string | undefined {
    return this.route.snapshot.queryParams[key] || undefined;
  }

  public async set(key: string, value: string | undefined): Promise<void> {

    const allUrlParameters = { ...this.route.snapshot.queryParams };
    allUrlParameters[key] = value;
    await this.router.navigate([], { relativeTo: this.route, queryParams: allUrlParameters });
  }
}
